import ApiService from "../../paywall/services/ApiService";
import { UCL } from '../../paywall/core/UserClientLibs'

const meteringHelper = {
    obtenerCookieSuscriptor: function (apiUrl, token, config) {
        var deleteMeteringCookie = function (config) {
            for (let [, value] of Object.entries(config.CookiesMetering)) {
                deleteCookieName(value);
            }
        };

        var deleteCookieName = function (name) {
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/" + (document.domain === 'localhost' ? "" : "; domain=" + config.dominioCookie);
        };

        var createCookie = function (name, value, seconds, domain) {
            var expires = "";
            if (seconds) {
                var date = new Date();
                date.setTime(date.getTime() + (seconds * 1000));
                expires = "; expires=" + date.toGMTString();
            }
            var cookieDomain = (document.domain === 'localhost' ? "" : "; domain=" + domain);
            document.cookie = name + "=" + value + expires + cookieDomain + "; path=/";
        };

        var readCookie = function (name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        };
        const customHandleResponse = (response) => {
            if (response.data) {
                createCookie(config.CookiesMetering["metering"], response.data, config.cookieExpirationTime, config.dominioCookie);
            }
        }
        const customHandleErrorResponse = (error) => {
            return new Promise((resolve, reject) => {
                switch (error.response.status) {
                    case 401:
                        UCL.LogoutAsync({ embedShortCircuit: true, redirect: 'login', isVoluntary: false })
                        break;
                    case 500:
                        createCookie(config.CookiesMetering["serviceDown"], true, 600, config.dominioCookie);
                        createCookie('metering_arc_ERROR', "response.status: 500 - " + ((error && error.statusText) ? error.statusText : ""), 600, config.dominioCookie);
                        break;
                    default:
                        console.error('Error:', error.message);
                        createCookie(config.CookiesMetering["serviceDown"], true, 600, config.dominioCookie);
                        createCookie('metering_arc_ERROR', error.message, 600, config.dominioCookie);
                }
                reject();
            });
        }
        var productosPremium = readCookie("ProductoPremiumId");
        var cookieMtrng = readCookie(config.CookiesMetering["metering"]);
        var cookieMtrngSubscribed = false;
        if (cookieMtrng) {
            let arr = cookieMtrng.split('.');
            if (arr && arr.length > 0) {
                let e = arr[0].replace("entitlement=", "");
                console.log({ entitlement: e });
                cookieMtrngSubscribed = e && e.toLocaleUpperCase() == "SUBSCRIBED";
            }
        }
        var esPremium = productosPremium ? productosPremium.split(',').includes('2') : false;
        if (esPremium || (cookieMtrngSubscribed && !esPremium)) {
            deleteMeteringCookie(config);
        }
        deleteCookieName(config.CookiesMetering["serviceDown"]);
        deleteCookieName("metering_arc_ERROR");

        return ApiService.get(apiUrl, customHandleResponse, customHandleErrorResponse)
    }
};

export default meteringHelper;


// WEBPACK FOOTER //
// ./Statics/scripts/common/helpers/metering-api-fetch.js